import React from "react";
import cloudLogo from "../../../assets/lottie/cloud.json";
// Mui
import { Backdrop } from "@mui/material";

// Jds
import { Spinner, Text } from "@jds/core";
import Lottie from "lottie-react";

export default function PageLoader(props) {
  return (
    <Backdrop {...props} sx={{ zIndex: 50 }}>
      {/* <Spinner label={<Text text={props?.label} {...props.labelprops} />} /> */}
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
        }}>
        <div style={{ width: 100, height: 100 }}>
          <Lottie animationData={cloudLogo} loop={true} autoplay={true} />
        </div>
        {props?.label && (
          <Text appearance="body-m" text={props?.label} color="white" />
        )}
      </div>
    </Backdrop>
  );
}
